<table>
	<thead>
		<tr>
			<th>{{ 'generic-calendar.week.label' | translate }}</th>
			<th>{{ 'generic-calendar.week-days.monday' | translate }}</th>
			<th>{{ 'generic-calendar.week-days.tuesday' | translate }}</th>
			<th>{{ 'generic-calendar.week-days.wednesday' | translate }}</th>
			<th>{{ 'generic-calendar.week-days.thursday' | translate }}</th>
			<th>{{ 'generic-calendar.week-days.friday' | translate }}</th>
			<th>{{ 'generic-calendar.week-days.saturday' | translate }}</th>
			<th>{{ 'generic-calendar.week-days.sunday' | translate }}</th>
		</tr>
	</thead>
	<tbody>
		@for (week of weeks; track week) {
			<tr>
				<td class="weekcell">{{ week.nr }}</td>
				@for (day of week.days; track day) {
					<td [ngClass]="{ in_month: day.in_month }" (click)="onDayClick(day)" [class.no-appointments]="day.appointments.length === 0">
						<div class="day-header">
							{{ day.day }}
							@if (addAppointmentIcon && day.appointments.length === 0) {
								<mat-icon class="acies_add" svgIcon="acies_add">
									<!-- Conditional rendering -->
								</mat-icon>
							}
						</div>
						@for (appointment of day.appointments; track appointment) {
							<div (click)="onAppointmentClick(appointment)" class="appointment {{ appointment.appointmentType.toLowerCase() }}">
								{{ appointment.title }}
								<button mat-icon-button (click)="deleteAppointment($event, appointment)">
									<mat-icon svgIcon="acies_delete"></mat-icon>
								</button>
							</div>
						}
					</td>
				}
			</tr>
		}
	</tbody>
</table>
